<template>
  <div class="banner">
    <Form :model="searchCondition" inline>
      <FormItem label="分类名称" :label-width="70">
          <Input type="text"  v-model="searchCondition.keywords" clearable></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/course/classify-list"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onDetail(row)">编辑首页配置</Button>
          </div>
        </template>
      </Grid>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchCondition: {
        keywords: "",
        init() {
          this.keywords = "";
        }
      },
      tableColumns: [
        { title: "分类名称", key: "name", align: "center", minWidth: 200 },
        {
          title: "排序",
          key: "sort",
          align: "center",
          minWidth: 120
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 120,
          fixed: "right"
        }
      ]
    };
  },
  methods: {
    // on-event
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.grid.searchRefresh();
    },
    rowsFormatter(rows) {
      rows.forEach(item => {

      });
    },
    onDetail(row) {
      this.$router.push({
        name: "MobileRecomment",
        query: {
          id: row.id //row前面不用加前缀
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.bannner {
  .btn-group {
    float: left;
  }
  .page {
    float: right;
  }
}
</style>
